export default "__VITE_ASSET__DkzME6Ha__"